import React, { useEffect, useState } from 'react';
import {
  Container,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Spinner,
  Alert,
  Tooltip,
  OverlayTrigger,
  InputGroup
} from 'react-bootstrap';
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaSave,
  FaTimes,
  FaCalendarAlt,
  FaFileContract,
  FaPaperPlane,
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
  FaEye,
  FaSync,
  FaBullhorn,
  FaSearch,
  FaBan
} from 'react-icons/fa';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';
// import { db } from '../../services/firebaseConnection';
import { useFirebaseConnection } from '../../services/useFirebaseConnection';
// import AutentiqueService from '../../services/autentiqueService';

// Converte qualquer valor (Timestamp do Firestore, Date, string) para Date
const toDate = (value) => {
  if (!value) return null;
  if (typeof value === 'object' && typeof value.toDate === 'function') return value.toDate(); // Firestore Timestamp
  if (value instanceof Date) return value;
  const d = new Date(value);
  return isNaN(d) ? null : d;
};

// Formata para 'YYYY-MM-DD' (sem usar toISOString, evitando problemas de fuso)
const formatYmd = (value) => {
  const d = toDate(value);
  if (!d) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};



export default function PedidoForm({ pedido, clientes, planos, onSave, onCancel, error }) {


  const [equipamentos, setEquipamentos] = useState([]);
  const { db } = useFirebaseConnection();

  useEffect(() => {
  const fetchEquipamentos = async () => {
    try {
      const equipamentosSnapshot = await getDocs(collection(db, 'equipamentos'));
      const listaEquipamentos = equipamentosSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEquipamentos(listaEquipamentos);
    } catch (error) {
      console.error('Erro ao buscar equipamentos:', error);
    }
  };

  fetchEquipamentos();
}, []);

  // Função para obter data atual no formato YYYY-MM-DD
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Função para calcular data de término
  const calculateEndDate = (startDate, duracao, unidade) => {
    if (!startDate || !duracao || !unidade) return '';
    
    const start = new Date(startDate);
    const duration = parseInt(duracao);
    
    switch (unidade.toLowerCase()) {
      case 'dias':
        start.setDate(start.getDate() + duration);
        break;
      case 'semanas':
        start.setDate(start.getDate() + (duration * 7));
        break;
      case 'meses':
        start.setMonth(start.getMonth() + duration);
        break;
      case 'anos':
        start.setFullYear(start.getFullYear() + duration);
        break;
      default:
        return '';
    }
    
    return start.toISOString().split('T')[0];
  };

const generateParcelas = (startDate, duracao, unidade, valorMensalidade) => {
  if (!startDate || !duracao || !unidade || !valorMensalidade) return [];

  const u = String(unidade).toLowerCase();
  const valor = Number(valorMensalidade) || 0;

  if (u === 'dias') {

    const venc = startDate;

    return [{
      numero: 1,
      valor,
      dataVencimento: venc,
      pago: false,
      dataPagamento: ''
    }];
  }

  const parcelas = [];
  const duration = parseInt(duracao, 10) || 0;
  const base = new Date(startDate);

  for (let i = 0; i < duration; i++) {
    const d = new Date(base);
    if (u === 'semanas') d.setDate(d.getDate() + i * 7);
    else if (u === 'meses') d.setMonth(d.getMonth() + i);
    else if (u === 'anos') d.setFullYear(d.getFullYear() + i);
    else break;

    parcelas.push({
      numero: i + 1,
      valor,
      dataVencimento: d.toISOString().slice(0, 10),
      pago: false,
      dataPagamento: ''
    });
  }

  return parcelas;
};


  // CORREÇÃO CRÍTICA: Inicialização mais robusta do formData
  const initializeFormData = (pedidoData) => {
    if (pedidoData && pedidoData.id) {
      // Modo edição - preservar ID
      return {
        id: pedidoData.id, // CRÍTICO: Preservar o ID
        clienteId: pedidoData.clienteId || '',
        clienteNome: pedidoData.clienteNome || '',
        planoId: pedidoData.planoId || '',
        planos: pedidoData.planos || '',
        quantidadeAnuncios: pedidoData.quantidadeAnuncios || 1, // NOVO CAMPO
        valor: pedidoData.valor || '',
        desconto: pedidoData.desconto || '0',
        dataInicio: pedidoData.dataInicio || getToday(),
        dataTermino: pedidoData.dataTermino || '',
        status: pedidoData.status || 'ativo', // NOVO CAMPO - Status do pedido
        statusContrato: pedidoData.statusContrato || 'pendente',
        autentiqueDocId: pedidoData.autentiqueDocId || null,
        contratoEnviado: pedidoData.contratoEnviado || false,
        linkAssinatura: pedidoData.linkAssinatura || null,
        dataEnvioContrato: pedidoData.dataEnvioContrato || null,
        dataAssinaturaContrato: pedidoData.dataAssinaturaContrato || null,
        parcelas: pedidoData.parcelas || [],
        equipamentos: pedidoData.equipamentoNome || '',
        equipamentoId: pedidoData.equipamentoId || '',
      };
    } else {
      // Modo criação - sem ID
      console.log("Inicializando form para CRIAÇÃO - sem ID");
      return {
        id: null, // CRÍTICO: Null para novo pedido
        clienteId: '',
        clienteNome: '',
        planoId: '',
        planos: '',
        quantidadeAnuncios: 1, // NOVO CAMPO - padrão 1
        valor: '',
        desconto: '0',
        dataInicio: getToday(),
        dataTermino: '',
        status: 'ativo', // NOVO CAMPO - Status padrão ativo
        statusContrato: 'pendente',
        autentiqueDocId: null,
        contratoEnviado: false,
        linkAssinatura: null,
        dataEnvioContrato: null,
        dataAssinaturaContrato: null,
        parcelas: []
      };
    }
  };

  const [formData, setFormData] = useState(() => initializeFormData(pedido));

  // CORREÇÃO: Calcular valor final baseado no valor do plano, não fixo em R$ 250
  const quantidadeAnuncios = parseInt(formData.quantidadeAnuncios || 1);
  const valorDoPlano = parseFloat(formData.valor || 0); // Valor do plano selecionado
  const valorBase = quantidadeAnuncios * valorDoPlano; // Quantidade × Valor do plano
  const desconto = parseFloat(formData.desconto || 0);
  const valorMensalFinal = valorBase - desconto;

  // CORREÇÃO CRÍTICA: useEffect mais específico
  useEffect(() => {
    const newFormData = initializeFormData(pedido);
    setFormData(newFormData);
  }, [pedido?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'equipamentoId') {
      const equipamentoSelecionado = equipamentos.find(e => e.id === value);
      setFormData(prev => ({
        ...prev,
        equipamentoId: value,
        equipamentoNome: equipamentoSelecionado?.nome || ''
      }));
    }

    if (name === 'clienteId') {
      // CORREÇÃO CRÍTICA: Usar CNPJ como clienteId
      const selectedCliente = clientes.find(c => c.documentId === value || c.cnpj === value);
      
      setFormData(prev => ({
        ...prev,
        clienteId: value, // CNPJ como ID
        clienteNome: selectedCliente?.nome || ''
      }));
    } else if (name === 'planoId') {
      const selectedPlano = planos.find(p => p.id === value);
      
      if (selectedPlano) {
        let novaDataTermino = '';
        let novasParcelas = [];
        
        if (formData.dataInicio) {
          novaDataTermino = calculateEndDate(formData.dataInicio, selectedPlano.duracao, selectedPlano.unidade);
          // CORREÇÃO: Usar valor do plano × quantidade de anúncios
          const valorComDesconto = (quantidadeAnuncios * parseFloat(selectedPlano.valor)) - parseFloat(formData.desconto || 0);
          novasParcelas = generateParcelas(formData.dataInicio, selectedPlano.duracao, selectedPlano.unidade, valorComDesconto);
        }
        
        setFormData(prev => ({
          ...prev,
          planoId: value,
          planos: selectedPlano.nome,
          valor: selectedPlano.valor, // Valor do plano
          dataTermino: novaDataTermino,
          parcelas: novasParcelas
        }));
      }
    } else if (name === 'dataInicio') {
      let novaDataTermino = '';
      let novasParcelas = [];
      
      const planoAtual = planos.find(p => p.id === formData.planoId);
      if (planoAtual && value) {
        novaDataTermino = calculateEndDate(value, planoAtual.duracao, planoAtual.unidade);
        novasParcelas = generateParcelas(value, planoAtual.duracao, planoAtual.unidade, valorMensalFinal);
      }
      
      setFormData(prev => ({
        ...prev,
        [name]: value,
        dataTermino: novaDataTermino || prev.dataTermino,
        parcelas: novasParcelas.length > 0 ? novasParcelas : prev.parcelas
      }));
    } else if (name === 'quantidadeAnuncios' || name === 'desconto') {
      // CORREÇÃO: Recalcular parcelas quando quantidade de anúncios ou desconto mudar
      const novaQuantidade = name === 'quantidadeAnuncios' ? parseInt(value || 1) : quantidadeAnuncios;
      const novoDesconto = name === 'desconto' ? parseFloat(value || 0) : desconto;
      const novoValorBase = novaQuantidade * valorDoPlano; // Usar valor do plano
      const novoValorFinal = novoValorBase - novoDesconto;
      
      let novasParcelas = formData.parcelas;
      
      const planoAtual = planos.find(p => p.id === formData.planoId);
      if (planoAtual && formData.dataInicio && novoValorFinal > 0) {
        novasParcelas = generateParcelas(formData.dataInicio, planoAtual.duracao, planoAtual.unidade, novoValorFinal);
      }
      
      setFormData(prev => ({
        ...prev,
        [name]: value,
        parcelas: novasParcelas
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

const handleParcelaChange = (index, field, value) => {
  const novasParcelas = [...formData.parcelas];

  if (field === 'pago') {
    novasParcelas[index] = {
      ...novasParcelas[index],
      pago: value,
      dataPagamento: value ? getToday() : '',
      valorPago: value ? (novasParcelas[index].valorPago ?? novasParcelas[index].valor) : '' // autopreenche só se não tiver valorPago
    };
  } else {
    novasParcelas[index] = {
      ...novasParcelas[index],
      [field]: value
    };
  }

  setFormData(prev => ({
    ...prev,
    parcelas: novasParcelas
  }));
};

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validações básicas
    if (!formData.clienteId) {
      alert('Por favor, selecione um cliente');
      return;
    }
    
    if (!formData.planoId) {
      alert('Por favor, selecione um plano');
      return;
    }
    
    if (!formData.dataInicio) {
      alert('Por favor, informe a data de início');
      return;
    }
    
    if (!formData.quantidadeAnuncios || formData.quantidadeAnuncios < 1) {
      alert('Por favor, informe a quantidade de anúncios (mínimo 1)');
      return;
    }
    
    onSave(formData);
  };

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header as="h5">
        {formData.id ? `Editar Pedido (ID: ${formData.id.substring(0, 8)}...)` : 'Novo Pedido'}
      </Card.Header>
      <Card.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Cliente *</Form.Label>
                <Form.Select
                  name="clienteId"
                  value={formData.clienteId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione um cliente</option>
                  {clientes.map(cliente => (
                    <option key={cliente.documentId} value={cliente.documentId}>
                      {cliente.nome} - CNPJ: {cliente.documentId}
                    </option>
                  ))}
                </Form.Select>

              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Equipamentos *</Form.Label>
                <Form.Select
                  name="equipamentoId"
                  value={formData.equipamentoId || ''}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione um equipamento</option>
                  {equipamentos.map(equip => (
                    <option key={equip.id} value={equip.id}>
                      {equip.nome} {/* Ajuste conforme o campo do seu documento */}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Plano *</Form.Label>
                <Form.Select
                  name="planoId"
                  value={formData.planoId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione um plano</option>
                  {planos.map(plano => (
                    <option key={plano.id} value={plano.id}>
                      {plano.nome} - R$ {plano.valor}/mês ({plano.duracao} {plano.unidade})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Anúncios *</Form.Label>
                <Form.Control
                  type="number"
                  name="quantidadeAnuncios"
                  value={formData.quantidadeAnuncios}
                  onChange={handleChange}
                  min="1"
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Valor Base (R$)</Form.Label>
                <Form.Control
                  type="text"
                  value={`R$ ${valorBase.toFixed(2)}`}
                  readOnly
                  style={{ backgroundColor: '#e9ecef', fontWeight: 'bold' }}
                />
              </Form.Group>
            </Col>
            
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Desconto (R$)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="desconto"
                  value={formData.desconto}
                  onChange={handleChange}
                  min="0"
                  max={valorBase}
                />
              </Form.Group>
            </Col>
            
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Valor Mensal (R$)</Form.Label>
                <Form.Control
                  type="text"
                  value={`R$ ${valorMensalFinal.toFixed(2)}`}
                  readOnly
                  style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', color: '#28a745' }}
                />
              </Form.Group>
            </Col>
            
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Data de Início *</Form.Label>
                <Form.Control
                  type="date"
                  name="dataInicio"
                  value={formData.dataInicio}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Data de Término</Form.Label>
                <Form.Control
                  type="date"
                  name="dataTermino"
                  value={formData.dataTermino}
                  onChange={handleChange}
                  readOnly
                  style={{ backgroundColor: '#e9ecef' }}
                />
              </Form.Group>
            </Col>
          </Row>
          
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Status do Contrato</Form.Label>
                <Form.Select
                  name="statusContrato"
                  value={formData.statusContrato}
                  onChange={handleChange}
                >
                  <option value="pendente">Pendente</option>
                  <option value="aguardando_assinatura">Aguardando Assinatura</option>
                  <option value="assinado">Assinado</option>
                  <option value="dispensado">Dispensado</option>
                </Form.Select>
              </Form.Group>
            </Col>
            
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Status do Pedido</Form.Label>
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="ativo">Ativo</option>
                  <option value="finalizado">Finalizado</option>
                  <option value="cancelado">Cancelado</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Enviar contrato</Form.Label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {

                        
                        // const reader = new FileReader();
                        // reader.onload = (event) => {
                        //   setFormData(prev => ({
                        //     ...prev,
                        //     contratoEnviado: true,
                        //     linkAssinatura: event.target.result // Armazenar o conteúdo do arquivo
                        //   }));
                        // };
                        // reader.readAsDataURL(file);
                      }
                    }}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Informações do Contrato */}
          {(formData.contratoEnviado || formData.linkAssinatura) && (
            <Row>
              <Col>
                <Card className="mb-3 border-info">
                  <Card.Header className="bg-info text-white">
                    <FaFileContract className="me-2" />
                    Informações do Contrato
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      {formData.dataEnvioContrato && (
                        <Col md={3}>
                          <strong>Data de Envio:</strong><br />
                          {formData.dataEnvioContrato}
                        </Col>
                      )}
                      {formData.dataAssinaturaContrato && (
                        <Col md={3}>
                          <strong>Data de Assinatura:</strong><br />
                          {formData.dataAssinaturaContrato}
                        </Col>
                      )}
                      {formData.autentiqueDocId && (
                        <Col md={3}>
                          <strong>ID Autentique:</strong><br />
                          <small className="text-muted">{formData.autentiqueDocId}</small>
                        </Col>
                      )}
                      {formData.linkAssinatura && (
                        <Col md={3}>
                          <strong>Link de Assinatura:</strong><br />
                          <a 
                            href={formData.linkAssinatura} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary"
                          >
                            <FaEye className="me-1" />
                            Abrir Contrato
                          </a>
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Seção de Parcelas  */}
          {formData.parcelas.length > 0 && (
            <Row>
              <Col>
                <Card className="mt-3">
                  <Card.Header>
                    <h6 className="mb-0">
                      <FaCalendarAlt className="me-2" />
                      Parcelas ({formData.parcelas.length}x R$ {valorMensalFinal.toFixed(2)})
                    </h6>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      {formData.parcelas.map((parcela, index) => (
                        <Col md={3} key={index} className="mb-3">
                          <Card className={`h-100 ${parcela.pago ? 'border-success' : 'border-warning'}`}>
                          <Card.Header className={`py-2 ${parcela.pago ? 'bg-success text-white' : 'bg-warning text-dark'} d-flex align-items-center justify-content-between`}>
                            <small>Parcela {parcela.numero}</small>
                            <Form.Switch
                              id={`switch-pago-${index}`}
                              label="Pago"
                              checked={parcela.pago}
                              onChange={(e) => handleParcelaChange(index, 'pago', e.target.checked)}
                              className="ms-2"
                              size="sm"
                            />
                          </Card.Header>
                            <Card.Body className="py-2">
                              <div className="mb-2">
                                <strong>R$ {parcela.valor.toFixed(2)}</strong>
                              </div>
                                <Form.Label className="small">Vencimento:</Form.Label>
                                  <Form.Control
                                    type="date"
                                    size="sm"
                                    value={formatYmd(parcela.dataVencimento)}
                                    onChange={(e) => handleParcelaChange(index, 'dataVencimento', e.target.value)}
                                    className="mb-2"
                                  />

                              {/* Campo invalidar boleto */}
                              {/* {!parcela.pago &&
                                <div>

                                  <Button
                                    variant="danger"
                                    size="sm"
                                    className="my-2 w-100"
                                    onClick={() => {}}
                                    
                                  >
                                    <FaCheckCircle className="me-1" /> Invalidar Boleto
                                  </Button>
                                </div>
                              } */}

                              {!parcela.pago ? (
                                <div>

                                  <Button
                                    variant="primary"
                                    size="sm"
                                    className="my-2 w-100"
                                    onClick={() => {
                                      if (parcela.invoiceUrl) {
                                        window.open(parcela.invoiceUrl, '_blank', 'noopener,noreferrer');
                                      }
                                    }}
                                    disabled={!parcela.invoiceUrl}
                                    
                                  >
                                    <FaCheckCircle className="me-1" /> Baixar Boleto
                                  </Button>
                                </div>
                              ) : (
                                <div>
                                      <Button
                                        variant="secondary"
                                        size="sm"
                                        className="my-2 w-100"
                                        onClick={() => {
                                          if (parcela.invoiceUrl) {
                                            window.open(parcela.invoiceUrl, '_blank', 'noopener,noreferrer');
                                          }
                                        }}
                                        disabled={!parcela.invoiceUrl}
                                        
                                      >
                                        <FaCheckCircle className="me-1" /> Baixar Boleto
                                        <a href={parcela.invoiceUrl} target="_blank" rel="link do pagamento da parcela"></a>
                                      </Button>
                                </div>
                              )}

                              {parcela.pago && (
                                <>
                                  <Form.Label className="small">Data de Pagamento:</Form.Label>
                                  <Form.Control
                                    type="date"
                                    size="sm"
                                    value={formatYmd(parcela.dataPagamento) || ''}
                                    onChange={(e) => handleParcelaChange(index, 'dataPagamento', e.target.value)}
                                    className="mb-2"
                                  />

                                  <Form.Label className="small">Valor Pago:</Form.Label>
                                  <div className='d-flex align-items-center justify-content-center gap-2'>
                                  R$
                                  <Form.Control
                                    type="number"
                                    size="sm"
                                    min="0"
                                    step="0.01"
                                    value={parcela.valorPago ?? parcela.valor}
                                    // value={(parcela) => {
                                    //   if (parcela.valorPago == undefined || parcela.valorPago == null) {
                                    //     return parcela.valor;
                                    //   } 
                                    // }}
                                    // onChange={(e) => handleParcelaChange(index, 'valorPago', parseFloat(e.target.value))}
                                    onChange={(e) => {
                                    const v = e.target.value;
                                    // permite limpar o campo (''), senão converte para número
                                    handleParcelaChange(index, 'valorPago', v === '' ? '' : Number(v));
                                    }}
                                    className="mb-2"
                                  />
                                  </div>
                                </>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          <div className="d-flex justify-content-end mt-4">
            <Button variant="secondary" onClick={onCancel} className="me-2">
              <FaTimes className="me-1" /> Cancelar
            </Button>
            <Button variant="success" type="submit">
              <FaSave className="me-2" /> {formData.id ? 'Atualizar' : 'Criar'}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

